import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { View } from 'foundations-components/components/View';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { currentOrderedProductLevels } from 'self-service-api/constants/ProductLevels';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useAppSelector } from '../../reducers';
import { ownedHubSpotCreditsTotalSelector, productsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { bundledProductLinesForSkuIdSelector, highestProductLevelFromSkuIdsSelector, productForSkuIdSelector, skuIdHasBundledProductsSelector } from '../../selectors/ProductsSelectors';
import { navItemForProductLineSelector } from '../../selectors/RoutingSelectors';
import HubSpotCreditsFeatures from '../key-features/HubSpotCreditsFeatures';
import { HubSpotCreditsTilesContainer } from '../merch-card/hubspot-credits/HubSpotCreditsTilesContainer';
import BillingNameTitle from './BillingNameTitle';
import UnlockAIHeader from './UnlockAIHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const productLinePriority = ['OPERATIONS', 'SERVICE', 'SALES', 'MARKETING', 'CMS'];
const UnlockAIContent = () => {
  var _sortedProductInvento;
  const productInventory = useAppSelector(productsFromProductInventorySelector);
  const skuIds = productInventory.map(product => product.currentSkuId);
  const highestProductLevel = useAppSelector(state => highestProductLevelFromSkuIdsSelector(state, {
    skuIds
  }));
  const sortedProductInventory = useAppSelector(state => {
    return productInventory.sort((a, b) => {
      // if not in currentOrderedProductLevels, put it at the end
      if (a.productLevel === 'BASIC' || !currentOrderedProductLevels.includes(a.productLevel)) {
        return 1;
      }
      if (b.productLevel === 'BASIC' || !currentOrderedProductLevels.includes(b.productLevel)) {
        return -1;
      }

      // If multiple products have the same product level, sort by bundled products / product line priority
      if (a.productLevel === b.productLevel) {
        // bundled products have higher priority
        if (skuIdHasBundledProductsSelector(state, {
          skuId: a.currentSkuId
        })) {
          return -1;
        }
        if (skuIdHasBundledProductsSelector(state, {
          skuId: b.currentSkuId
        })) {
          return 1;
        }
        return productLinePriority.indexOf(a.productLine) - productLinePriority.indexOf(b.productLine);
      }

      // sort by product level priority, Ent being the highest priority
      return currentOrderedProductLevels.indexOf(b.productLevel) - currentOrderedProductLevels.indexOf(a.productLevel);
    });
  });
  const ownsAdditionalCredits = useAppSelector(state => {
    const ownedQuantity = ownedHubSpotCreditsTotalSelector(state);
    return ownedQuantity && ownedQuantity > 0;
  });
  const skuId = (_sortedProductInvento = sortedProductInventory[0]) === null || _sortedProductInvento === void 0 ? void 0 : _sortedProductInvento.currentSkuId;
  const subscreen = useAppSelector(state => {
    const isBundle = skuIdHasBundledProductsSelector(state, {
      skuId
    });
    if (isBundle) {
      return bundledProductLinesForSkuIdSelector(state, {
        skuId
      }).map(productLine => {
        return navItemForProductLineSelector(state, productLine);
      });
    }
    const productLine = productForSkuIdSelector(state, {
      skuId
    }).productLine;
    if (!productLine) {
      return NavItemEnum.SUITE;
    }
    return navItemForProductLineSelector(state, productLine);
  });
  return /*#__PURE__*/_jsx(PageSection, {
    children: /*#__PURE__*/_jsxs(View, {
      backgroundColor: "fill-surface-default",
      padding: "1300",
      children: [/*#__PURE__*/_jsx(UnlockAIHeader, {
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "pricingPage.pages.hubspot-credits.unlockAI.title",
          options: {
            billingName: highestProductLevel === 'STARTER' ? /*#__PURE__*/_jsx(BillingNameTitle, {
              bilingNameKey: "crm-suite-starter-bundle"
            }) : /*#__PURE__*/_jsx(BillingNameTitle, {
              skuId: skuId
            })
          }
        })
      }), ownsAdditionalCredits ? null :
      /*#__PURE__*/
      //TODO: update to inbound merch cards
      _jsx(HubSpotCreditsTilesContainer, {
        screen: NavItemEnum.HUBSPOT_CREDITS,
        hubSpotCreditsFeature: "CUSTOMER_AGENT",
        productApiName: "hubspot-credits-committed",
        shouldShowUnlockHubSpotCreditsInfo: false,
        unlockHubSpotCreditsSkuIds: []
      }), /*#__PURE__*/_jsx(HubSpotCreditsFeatures, {
        subscreen: subscreen
      })]
    })
  });
};
export default UnlockAIContent;